import { ReactComponent as ErrorIllustration } from '../assets/ErrorIllustration.svg';
import { Button } from '@/components/ui/button';
import { useResetQuestionnaire } from '../hooks/useResetQuestionnaire';
import type { ResetOptions } from '../hooks/useResetQuestionnaire';
import { useEffect, useState } from 'react';

interface ErrorPageProps {
  /**
   * Options forwarded to the reset. Both the `/error` route and the
   * ErrorBoundary fallback pass `{ clearStorage: true }` so "Recommencer"
   * always reloads — clearing the stale persisted state behind the error and
   * escaping the stuck boundary.
   */
  resetOptions?: ResetOptions;
}

export const ErrorPage = ({ resetOptions }: ErrorPageProps = {}) => {
  const reset = useResetQuestionnaire();
  const [, setError] = useState<Error | null>(null);

  useEffect(() => {
    setError(window.history.state?.error ?? null);
  }, []);

  return (
    <div className="flex flex-col w-full items-center px-4 n2xs:px-6 nsm:px-0 nsm:pt-15 pb-4">
      <main className="w-full mt-8 px-0 nsm:px-8 flex flex-col justify-between items-center mb-auto">
        <div className="flex flex-col items-center">
          <ErrorIllustration />
          <h1 className="text-center font-bold text-secondary text-xl mt-8">
            Oups, il y a eu un souci.
            <br />
            Nous sommes sur le coup !
          </h1>
          <p className="mt-3 inline">
            Une erreur est survenue.
            {/* <code className="align-text-top ms-1">{error?.toString()}</code> */}
          </p>
          <b className="text-center font-semibold">
            Cliquez sur le bouton ci-dessous pour recommencer le questionnaire.
          </b>
        </div>
      </main>
      <div className="pt-16">
        <Button
          variant="ctaPrimary"
          size="lg"
          onClick={() => reset(resetOptions)}
        >
          Recommencer
        </Button>
      </div>
    </div>
  );
};
